import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CancelToken, isCancel } from 'axios';
import AssetService from '../../Services/AssetService';
import RunCustomerOTAModalDisplay from './RunCustomerOTAModalDisplay';

import { HFX_FLASH_JOB_COMMAND_ID } from '../../Constants/StaticUUIDs';

export default class RunCustomerOTAModal extends Component {
  static propTypes = {
    asset: PropTypes.shape({ _id: PropTypes.string }),
    toggleModal: PropTypes.func,
    customerOTAselected: PropTypes.shape({
      filename: PropTypes.string, // just the filename
      displayName: PropTypes.string, // the filename but maybe truncated for display
      name: PropTypes.string, // blob storage name
      type: PropTypes.string, // just the prefix like "hfx_flash"
      typeName: PropTypes.string, // name found from looking up in our types table
      properties: PropTypes.object, // from blob storage
      createdOn: PropTypes.string, // "x ago" string from properties.createdOn time
    }),
  };

  static defaultProps = {
    asset: { gtemplate: { name: '' } },
  };

  state = {
    error: '',
    canbus: '0',
    executeRequestPending: false,
    setSourceAddress: true,
  };

  assetService = new AssetService();
  source = CancelToken.source();

  componentWillUnmount() {
    this.source.cancel();
  }

  handleExecuteCustomerOTA = async (e) => {
    e.preventDefault();
    this.setState({ executeRequestPending: true });

    try {
      const {
        asset: { _id: assetID },
        customerOTAselected,
      } = this.props;

      switch (customerOTAselected.type) {
        default:
          throw new Error(`unknown job type ${customerOTAselected.type}`);
        case 'hfx_flash': {
          if (this.state.setSourceAddress && !this.state.source_address) {
            throw new Error(`fill in a target source address for HFX flashing`);
          }

          // source address is hard coded as parameter 0 for hfx_flash jobs
          // can bus is parameter 1
          let body;
          if (!this.state.setSourceAddress) {
            body = {
              jobParameters: ['any', this.state.canbus],
            };
          } else {
            body = {
              jobParameters: [this.state.source_address, this.state.canbus],
            };
          }

          await this.assetService.executeAssetCommand(
            assetID,
            {
              commandID: HFX_FLASH_JOB_COMMAND_ID,
              customerOTAfilename: customerOTAselected.filename,
              customerOTAtype: customerOTAselected.type,
            },
            body,
            this.source.token
          );

          this.setState({
            executeRequestPending: false,
          });
          this.props.toggleModal();
        }
      }
    } catch (err) {
      if (!isCancel(err)) {
        const error = err.response?.data?.message ?? err.message;
        this.setState({
          error,
          executeRequestPending: false,
        });
      }
    }
  };

  handlePropUpdate = ({ target: { name, value } }) => {
    this.setState({ [name]: value });
  };

  handleSourceAddressUpdate = (e) => {
    const { validity, value, name } = e.target;
    if (validity.valid) {
      this.setState({ [name]: value, sourceAddressError: '' });
    } else {
      const sourceAddressError = 'Integer between 0 and 255';
      this.setState({ sourceAddressError });
    }
  };

  handleSetSourceAddress = () => {
    this.setState({ setSourceAddress: !this.state.setSourceAddress });
  };

  render() {
    return (
      <RunCustomerOTAModalDisplay
        {...this.props}
        {...this.state}
        handleExecuteCustomerOTA={this.handleExecuteCustomerOTA}
        canbus={this.canbus}
        source_address={this.source_address}
        handlePropUpdate={this.handlePropUpdate}
        handleSourceAddressUpdate={this.handleSourceAddressUpdate}
        handleSetSourceAddress={this.handleSetSourceAddress}
      />
    );
  }
}
